(function($, App, Utils, Components){
  'use strict';
  const logger = new Logger('ReservedPrizesStatus');

  Components.create('ReservedPrizesStatus', {

    Selectors: {
      Container: '.responsive-card-table--status',
      Wrapper: '#reserved-prizes-filter-wrapper',
      SideBar: '.sidebar-wrapper',
      Loader: '.js-loader',
      CardInfo: '.card-info',
      Filter: '.reserved-prizes-filter',
      RemoveFilter: '.js-remove-filters',
      StatusFilter: 'select[name=reservation-status] option',
      CollectionFilter: 'select[name=collection-id] option',
      ReservationId: '.cancelReservationId',
      CancelModal: '.cancel-prize-modal',
      ModalTitle: '.prize-reservation-modal__title',
      ModalDate: '.prize-reservation-modal__date',
      CloseCancelModal: '.js-close-modal',
    },

    loadData: function(url, append) {
      this.$loader.addClass('in fade-in');

      const ajaxData = {
        params: {
          collectionId: this.$collectionFilter.filter(':selected').val(),
          reservationStatus: this.$statusFilter.filter(':selected').val(),
          bare: true
        }
      };

      axios.get(url, ajaxData)
        .then((response) => {
          this.$loader.removeClass('in fade-in');
           this.$container.html(response.data);
          setTimeout(() => { this.pageSize();}, 100);
        })
        .catch(function (error) {
          logger.d("Couldn't get reserved prizes data: ", error);
        });
    },

    enableFiltering: function() {
      this.$filter.on('change', (e) => {
        this.$removeFilters.removeClass('hide');
        this.loadData(this.url, false);
      });
    },

    removeFilters: function() {
      $('option[data-select2-id]').prop('selected', false).trigger("change");
      this.$removeFilters.addClass('hide');
    },

    onResize: function() {
      let res = Utils.Responsive.getCurrentResolution();
      if (res.label == 'sm' || res.label == 'xs') {
        this.$wrapper.insertAfter(this.$sideBar);
      } else {
        this.$wrapper.insertBefore(this.$cardInfo);
      }
      Components.CustomSelect.init();
    },

    openModalCancelReservation(id, date, desc) {

      this.$cancelModal.trigger( "click" );
      $(this.Selectors.ModalTitle).html(desc);
      $(this.Selectors.ModalDate).html(date);
      $(this.Selectors.ReservationId).val(id);

      $(this.Selectors.CloseCancelModal).on('click', () => {
        vex.closeAll();
      })

    },

    init: function() {
      this.$container = $(this.Selectors.Container);
      this.$wrapper = $(this.Selectors.Wrapper);
      this.$sideBar = $(this.Selectors.SideBar);
      this.$cardInfo = $(this.Selectors.CardInfo);
      this.url = this.$wrapper.data('url');
      this.$loader = $(this.Selectors.Loader);
      this.$filter = $(this.Selectors.Filter);
      this.$statusFilter = $(this.Selectors.StatusFilter);
      this.$collectionFilter = $(this.Selectors.CollectionFilter);
      this.$removeFilters = $(this.Selectors.RemoveFilter);
      this.$cancelModal = $(this.Selectors.CancelModal);

      this.onResize();
      this.enableFiltering();

      this.$removeFilters.on('click', (e)=> {
        this.removeFilters();
      });

      const ctx = this;

      App.Window.on('resize.page', () => {
        setTimeout(()=>{  ctx.onResize(); }, 100);

      });

      const $cancelBtns = $('.cancel-prize');

      $cancelBtns.each(function() {
        $(this).on("click", function() {

          let params = Utils.jsonDA($(this), 'param');
          let id = params.resevation.id;
          let date = params.resevation.date;
          let desc = params.resevation.desc;

          ctx.openModalCancelReservation(id, date, desc)
        });
      });

    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);